import cloud from '~/assets/icons/cloud_2.svg';
import cloudRain from '~/assets/icons/cloud_rain.svg';
import snow from '~/assets/icons/snow.svg';
import sun from '~/assets/icons/sun.svg';
import { WeatherType } from '~/shared';

export const weatherIcons = {
	[WeatherType.EXTRASUNNY]: sun,
	[WeatherType.CLEAR]: sun,
	[WeatherType.CLOUDS]: cloud,
	[WeatherType.SMOG]: cloud,
	[WeatherType.FOG]: cloud,
	[WeatherType.OVERCAST]: cloud,
	[WeatherType.RAIN]: cloudRain,
	[WeatherType.THUNDER]: cloudRain,
	[WeatherType.CLEARING]: cloudRain,
	[WeatherType.NEUTRAL]: cloud,
	[WeatherType.SNOW]: snow,
	[WeatherType.BLIZZARD]: snow,
	[WeatherType.SNOWLIGHT]: snow,
	[WeatherType.XMAS]: snow,
	[WeatherType.HALLOWEEN]: cloud,
};
